






import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT} from '@/store/modules/authentication/types';
import {traceLogAccess} from '@/services';

import {Client} from '@/store/modules/authentication/interfaces';
import {ContextEnum} from '@/enums/context.enum';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {ClientEnum} from '@/enums/client.enum';

import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';

@Component({
  name: 'PbiDashboardDrdProjection',
  components: { ReportPowerBiContainer }
})
export default class PbiDashboardDrdProjectionPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.Ford], { brand: 'Ford', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '1769d1f3-5ba9-4fa0-ba7c-8b107b4a8620' });
    this.crrReport = this.dictReports.get([this.client.id]);

    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Dashbord DRD Projeção`);
  }
}
